import { ExperienceLevel } from "./UserService.types";

export const EXPERIENCE_LEVEL_CONFIG: Record<
  ExperienceLevel,
  { info: { name: string } }
> = {
  [ExperienceLevel.EntryLevel]: {
    info: {
      name: "Entry Level",
    },
  },
  [ExperienceLevel.Intermediate]: {
    info: {
      name: "Intermediate",
    },
  },
  [ExperienceLevel.Expert]: {
    info: {
      name: "Expert",
    },
  },
};

export const USE_LOCAL_STORAGE = true;
